define([], function () {
  return function (modalTranslations) {
    return {
      tClose: modalTranslations.close || null, // Alt text on close button
      tLoading: modalTranslations.loading || null, // Text that is displayed during loading. Can contain %curr% and %total% keys
      gallery: {
        tPrev: modalTranslations.gallery_previous || null, // Alt text on left arrow
        tNext: modalTranslations.gallery_next || null, // Alt text on right arrow
        tCounter: modalTranslations.gallery_counter || null // Markup for "1 of 7" counter
      },
      image: {
        tError: modalTranslations.image_error || null // Error message when image could not be loaded
      },
      ajax: {
        tError: modalTranslations.content_error || null // Error message when ajax request failed
      }
    }
  }
})
